import React, {
  useEffect,
  useRef,
  useState,
  useMemo,
  useCallback,
} from "react";
import {
  CreateRole,
  EditRole,
  deleteRole,
  getCreateRole,
  getManageRoleUser,
} from "../../API/api";
import { Space, Table, Spin, Tooltip, Popconfirm, Checkbox, theme } from "antd";
import TitleValue from "../cmOverview/tabs/seeker/TitleValue";
import { SearchOutlined, SyncOutlined } from "@ant-design/icons";
import { DebounceInput } from "react-debounce-input";
import styles from "./Managerole.module.css";
import VizHeader from "../VizHeader/VizHeader";
import VizButton from "../VizButtons/VizButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import VizParagraph from "../VizParagraph/VizParagraph";
import { submitRatingSuccessToast } from "../../utils";
import { toast } from "react-toastify";
import { Avatar, Card, Row, Col, Button } from "antd";
import { UserOutlined, DeleteOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";

export const filtering = (row, text) => {
  return (
    row &&
    row?.filter((row) =>
      Object.values(row)?.some((value) =>
        value?.toString().toLowerCase().includes(text.toLowerCase())
      )
    )
  );
};

const greyShades = [
  "#D3D3D3",
  "#DCDCDC",
  "#C0C0C0",
  "#A9A9A9",
  "#696969",
  "#778899",
  "#708090",
  "#808080",
  "#2F4F4F",
  "#333333",
];

const getRandomGreyShade = () => {
  return greyShades[Math.floor(Math.random() * greyShades.length)];
};
const applyFilterActive = (arr) => {
  const data = arr.filter((item) => item.active === true);
  return data;
};

export function SearchBar({
  searchValue,
  handleSearch,
  setSearchValue,
  setCurrentPage,
}) {
  return (
    <>
      <Space.Compact>
        <span className={styles.search}>
          <SearchOutlined />
          <DebounceInput
            debounceTimeout={0}
            placeholder="Search"
            autoComplete="off"
            outline={true}
            onChange={handleSearch}
            value={searchValue}
            allowClear
            style={{ border: "none", paddingLeft: "10px" }}
          />
          {searchValue.length > 0 && (
            <>
              <span
                className={styles.cross}
                onClick={() => {
                  setSearchValue("");
                }}
              >
                <svg
                  fill-rule="evenodd"
                  viewBox="64 64 896 896"
                  focusable="false"
                  data-icon="close-circle"
                  width="1em"
                  height="1em"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d="M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z"></path>
                </svg>
              </span>
            </>
          )}
        </span>
      </Space.Compact>
    </>
  );
}

// color of the avatar
// '#f56a00', "#87d068",'#1677ff','#fde3cf','#f56a00','#f56a00'
function BackGroundColor(role) {
  switch (role) {
    case "Admin":
      return "#fde3cf";
    case "Seeker":
      return "#f56a00";
    case "Expert":
      return "#87d068";
    case "CM":
      return "#1677ff";
    case "Emails":
      return "#E3BC01";
    // case role!=="Admin"||"CM"||"Seeker"||"Expert"||"Emails":
    default:
      return getRandomGreyShade();
  }
}

function AdminManageRole() {
  const [roles, setRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  const [rolesEdit, setRolesEdit] = useState(false);
  const [editPermission, setEditPermission] = useState(null);
  const [actionPerformed, setActionPerformed] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [createRole, setCreateRole] = useState(false);
  const [roleName, setRoleName] = useState("");
  const [searchRole, setSearchRole] = useState("");
  const [roleId, setRoleId] = useState(null);
  const [updateFlag, setUpdateFlag] = useState(false);
  const [deleteFlag, setDeleteFlag] = useState(false);
  const [permission, setPermission] = useState(null);
  const expertRecordsState = useSelector((state) => state.expertRecord);
  const role = useRef("");
  const rolesData = useMemo(
    () => roles && filtering(editPermission, searchRole),
    [editPermission, searchRole]
  );
  const manageRoleUsers = useCallback(() => {
    getManageRoleUser().then((res) => {
      setRole(res);
      setLoading(false);
    });
  }, []);
  // useEffect to call the api
  useEffect(() => {
    setLoading(true);
    setEditPermission(null);
    setCreateRole(false);
    setSelectedKeys([]);
    manageRoleUsers();
    setEditPermission(null);
    return () => {
      setRole(null);
    };
  }, [actionPerformed]);

  useEffect(() => {
    if (rolesEdit === true) {
      // setRolesEdit(false);
      setEditPermission(null);
      setSelectedKeys([]);
      setRolesEdit(false);
      setCreateRole(false);
      // setActionPerformed(!actionPerformed);
      setRolesEdit(false);
      setLoading(true);
      manageRoleUsers();
    }
  }, [expertRecordsState.refresh]);

  // event handler function for searching the role for the outside table
  const searchRecord = (event) => {
    setSearchRole(event.target.value);
  };

  // Function when we click on the edit button
  const onClickEdit = (value, name, id) => {
    const initialSelectedRowKeys = value
      .filter((item) => item.given)
      .map((item) => item.id);

    setSelectedKeys(initialSelectedRowKeys);
    // setState({ permissionValue: value });
    role.current = name;
    // Add index to data
    const dataWithIndex = value.map((item, index) => ({ ...item, index }));
    // setCheckRoleName(name);
    setEditPermission(dataWithIndex);
    setRoleId(id);
    setRoleName(name);
    setRolesEdit(true);
  };

  // handler for deleting the role
  const DeleteRole = (id) => {
    deleteRole(id, actionPerformed, setActionPerformed).then((res) => {
      if (res.status === 200) {
        setLoading(true);
        manageRoleUsers();
      }
    });
  };
  // function to select and deselect the checkbox in the edit and create permission
  const handleCheckboxChange = (key) => {
    setSelectedKeys((prevSelectedKeys) => {
      if (prevSelectedKeys.includes(key)) {
        return prevSelectedKeys.filter((selectedKey) => selectedKey !== key);
      } else {
        return [...prevSelectedKeys, key];
      }
    });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleSelectAllChange = (e) => {
    const filteredKeys = rolesData.map((item) => item.id);
    if (e.target.checked) {
      const allFilteredKeys = rolesData.map((item) => item.id);
      setSelectedKeys((prevSelectedKeys) => [
        ...new Set([...prevSelectedKeys, ...allFilteredKeys]),
      ]);
    } else {
      setSelectedKeys((prevSelectedKeys) =>
        prevSelectedKeys.filter((key) => !filteredKeys.includes(key))
      );
    }
  };
  // Out table column

  // Handler for searching permission inner table when click edit ot create new role
  const handleSearch = (event) => {
    setSearchValue(event.target.value);
  };
  const goBackToTable = () => {
    setEditPermission(null);
    setSelectedKeys([]);
    setRolesEdit(false);
    setCreateRole(false);
    // setActionPerformed(!actionPerformed);
    setRolesEdit(false);
    setLoading(true);
    manageRoleUsers();
  };

  // Inside table column
  const column = useMemo(
    () => [
      {
        title: TitleValue("Id"),
        dataIndex: "id",
        sorter: (a, b) => a.index - b.index,
        defaultSortOrder: "ascend",
        align: "center",
        width: 50,
        render: (_, raw) => (
          <span
            style={{
              wordBreak: 'break-word',
  overflowWrap: 'break-word',
              fontSize: "15px",
              fontWeight: "300",
              display: "flex",
              width: "50%",
              justifyContent: "flex-end",
              textAlign: "right",
            }}
          >
            {raw.index + 1}
          </span>
        ),
      },
      {
        title: TitleValue("Permission"),
        dataIndex: "name",
        sorter: (a, b) => a.name.localeCompare(b.name),
        align: "left",
        width: 300,
        render: (_, raw) => (
          <span
            style={{
              wordBreak: 'break-word',
  overflowWrap: 'break-word',
              fontSize: "15px",
              fontWeight: "300",
            }}
          >
            {raw.name}
          </span>
        ),
      },
      {
        title: (
          <Checkbox
            indeterminate={
              selectedKeys.length > 0 && selectedKeys.length < rolesData.length
            }
            onChange={handleSelectAllChange}
            checked={
              rolesData?.length > 0 &&
              rolesData?.every((item) => selectedKeys.includes(item.id))
            }
          />
        ),
        key: "id",
        width: 100,
        render: (_, record) => (
          <Checkbox
            key={record.id}
            checked={selectedKeys.includes(record.id)}
            onChange={() => handleCheckboxChange(record.id)}
          />
        ),
      },
    ],
    [selectedKeys, rolesData, handleSelectAllChange]
  );

  // Handler function when we click new user button to create the role and assign permission.
  const createNewUser = () => {
    setLoading(true);
    getCreateRole().then((res) => {
      if(res===undefined) return;
      const dataWithIndex = res.map((item, index) => ({ ...item, index }));
      // setCheckRoleName(name);
      setEditPermission(dataWithIndex);
      setLoading(false);
    });
    setCreateRole(true);
    setRoleName("");
    setRolesEdit(true);
  };

  const checkBoolean = (val) => {
    if (val === role.current) {
      return false;
    } else return true;
  };
  const updatedPermission = () => {
    setLoading(true);
    manageRoleUsers();
    const data = roles?.filter((item) => {
      if (item.roleId === roleId) {
        return item[0]?.permissions;
      }
    });
  };
  // Function when w

  useEffect(() => {
    if (rolesEdit) {
      updatedPermission();
    }
  }, [updateFlag]);

  const EditRolePermission = () => {
    setCreateRole(false);

    let name = roleName;
    const arr = selectedKeys?.map((item) => ({ id: item }));
    const payload = { roleId: roleId, roleName: roleName, permissions: arr };
    // const checkName = roles.filter((el) => {
    //   if (el.roleName === roleName) {
    //     return true;
    //   }
    //   return false;
    // });
    if (roleName.length == 0 && selectedKeys.length > 0) {
      return toast.warn(submitRatingSuccessToast("Enter the Role Name"), {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
    if (selectedKeys.length == 0 && roleName.length > 0) {
      return toast.warn(
        submitRatingSuccessToast("Please Select the permission"),
        {
          position: toast.POSITION.TOP_RIGHT,
        }
      );
    }
    if (roleName == "" && selectedKeys.length == 0) {
      return toast.warn(
        submitRatingSuccessToast("Enter the Role Name and set the permission"),
        {
          position: toast.POSITION.TOP_RIGHT,
        }
      );
    }
    if (roleName !== "" && selectedKeys.length > 0) {
      setLoading(true);
      EditRole(payload, checkBoolean(name)).then((res) => {
        if (res?.data?.success) {
          toast.success(submitRatingSuccessToast(res?.data?.message), {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        // setEditPermission(null);
        // setRolesEdit(false);
        // setActionPerformed(!actionPerformed);
        setUpdateFlag(!updateFlag);
        setLoading(false);
      });
    } else {
      setLoading(false);
      return toast.warn(submitRatingSuccessToast("This role already exists"), {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  const CreateRoleFun = () => {
    const arr = selectedKeys?.map((item) => ({ id: item }));
    const payload = { roleId: "", roleName: roleName, permissions: arr };
    const checkName = roles.filter((el) => {
      if (el.roleName == roleName) {
        return true;
      }
      return false;
    });
    // setLoading(true);
    if (roleName.length == 0 && selectedKeys.length > 0) {
      return toast.warn(submitRatingSuccessToast("Enter the Role Name"), {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
    if (selectedKeys.length == 0 && roleName.length > 0) {
      return toast.warn(
        submitRatingSuccessToast("Please Select the permission"),
        {
          position: toast.POSITION.TOP_RIGHT,
        }
      );
    }
    if (roleName == "" && selectedKeys.length == 0) {
      return toast.warn(
        submitRatingSuccessToast("Enter the Role Name and set the permission"),
        {
          position: toast.POSITION.TOP_RIGHT,
        }
      );
    }
    if (checkName.length === 0 && roleName !== "" && selectedKeys.length > 0) {
      setLoading(true);
      CreateRole(payload).then((res) => {
        if(res===undefined) return;
        if (res?.data?.success) {
          toast.success(submitRatingSuccessToast(res?.data?.message), {
            position: toast.POSITION.TOP_RIGHT,
          });
          setEditPermission(null);
          setSelectedKeys([]);
          setRolesEdit(false);
          setCreateRole(false);
          // setActionPerformed(!actionPerformed);
          setRolesEdit(false);
          setLoading(true);
          manageRoleUsers();
        }
      });
    } else {
      return toast.warn(submitRatingSuccessToast("This role already exists"), {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  // const cardStyle = {
  //   width: 300,
  //   transition: "box-shadow 0.3s ease-in-out",
  //   // backgroundColor: "#F2F2F2",
  //   height: "160px",
  // };

  const newRoles = roles && applyFilterActive(roles);
  return (
    <>
      {" "}
      {rolesEdit ? (
        <div style={{ padding: "30px", paddingTop: "15px" }}>
          {" "}
          <Spin
            spinning={loading}
            style={{
              // marginTop: "30px",
              width: "100%",
            }}
          >
            {!rolesEdit ? (
              <>
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    paddingBottom: "15px",
                    marginTop: "30px",
                  }}
                >
                  <div
                    style={{
                      width: "52%",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>
                      <SearchBar
                        searchValue={searchValue}
                        handleSearch={handleSearch}
                        setSearchValue={setSearchValue}
                        // setCurrentPage={setCurrentPage}
                      />
                    </span>
                    <span>
                      <div
                        style={{
                          fontSize: "20px",
                          display: "flex",
                          alignItems: "center",
                          fontWeight: "500",
                          textTransform: "none",
                        }}
                      >
                        List of Roles&nbsp;
                      </div>
                    </span>
                  </div>
                  <div
                    style={{
                      width: "48%",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <VizButton
                      size={2}
                      type={"Primary"}
                      onClick={createNewUser}
                    >
                      + New User Role
                    </VizButton>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div
                  style={{
                    width: "100%",
                    paddingBottom: "15px",
                    marginTop: "2.5px",
                  }}
                >
                  <div>
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        color: "1F93D2",
                      }}
                    >
                      <ArrowBackIcon
                        style={{
                          color: "1F93D2",
                          cursor: "pointer",
                          fontSize: "26px",
                        }}
                        onClick={goBackToTable}
                        fontSize="large"
                      />
                      <span
                        style={{
                          color: "1F93D2",
                          fontSize: "18px",
                          paddingLeft: "3px",
                        }}
                      >
                        Back
                      </span>
                    </span>
                  </div>
                </div>
                <div
                  className={styles.header}
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    padding: "15px",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      width: "52%",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>
                      <SearchBar
                        searchValue={searchRole}
                        handleSearch={searchRecord}
                        setSearchValue={setSearchRole}
                        // setCurrentPage={setCurrentPage}
                      />
                    </span>
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span style={{ paddingRight: "10px" }}>
                      <VizParagraph type={1}>
                        {" "}
                        {createRole ? "Create" : "Edit"}
                      </VizParagraph>
                      <span style={{ paddingLeft: "5px" }}>
                        <VizParagraph type={1}>Role&nbsp;</VizParagraph>
                      </span>

                      <Space.Compact style={{ paddingLeft: "10px" }}>
                        <span className={styles.search}>
                          <DebounceInput
                            debounceTimeout={0}
                            placeholder="Enter Role Name"
                            autoComplete="off"
                            outline={true}
                            value={roleName}
                            onChange={(e) => setRoleName(e.target.value)}
                            allowClear
                            style={{ border: "none" }}
                          />
                        </span>
                      </Space.Compact>
                    </span>
                    <VizButton
                      size={2}
                      type={"Primary"}
                      onClick={createRole ? CreateRoleFun : EditRolePermission}
                    >
                      {createRole ? "Create" : "Update"} Role
                    </VizButton>
                  </div>
                </div>
              </>
            )}
            <Table
              columns={column}
              rowClassName={(record, index) =>
                index % 2 === 0 ? "table-row-light" : "table-row-dark"
              }
              dataSource={rolesData}
              pagination={false}
              showSorterTooltip={false}
              // rowSelection={{}}
              scroll={!rolesEdit ? undefined : { y: 500 }}
              rowKey="id"
              style={{ marginTop: "10px" }}
              // rowSelection={!rolesEdit ? undefined  : { rowSelection }}
            />
          </Spin>
        </div>
      ) : (
        <>
          <div style={{ padding: "30px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "7px",
              }}
            >
              <SyncOutlined
                colSpan={3}
                span={2}
                onClick={() => {
                  setLoading(true);
                  manageRoleUsers();
                }}
                spin={loading}
                style={{ fontSize: "16px" }}
              />
            </div>
            <Spin
              spinning={loading}
              style={{
                marginTop: "30px",
                width: "100%",
              }}
            >
              <div className={styles.cardParent} style={{ padding: "30px" }}>
                <Row>
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      paddingBottom: "15px",
                    }}
                  >
                    <div
                      style={{
                        width: "52%",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span>
                        <SearchBar
                          searchValue={searchValue}
                          handleSearch={handleSearch}
                          setSearchValue={setSearchValue}
                          // setCurrentPage={setCurrentPage}
                        />
                      </span>
                      <span>
                        <div
                          style={{
                            fontSize: "20px",
                            display: "flex",
                            alignItems: "center",
                            fontWeight: "500",
                            textTransform: "none",
                          }}
                        >
                          List of Roles&nbsp;
                        </div>
                      </span>
                    </div>

                    <div
                      style={{
                        width: "48%",
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      {!deleteFlag &&
                      filtering(newRoles, searchValue)?.length > 0 ? (
                        // <Button
                        //   onClick={() => setDeleteFlag(true)}
                        //   style={{
                        //     cursor: "pointer",
                        //     backgroundColor: "#f56a00",
                        //     color: "#FFFFF5",
                        //     marginRight: "10px",
                        //     border: "1px solid #f56a00",
                        //     fontSize: "16px",
                        //   }}
                        // >
                        //   Delete
                        // </Button>
                        <button
                          className={styles.deleteButton}
                          onClick={() => setDeleteFlag(true)}
                        >
                          Delete Role
                        </button>
                      ) : filtering(newRoles, searchValue)?.length > 0 ? (
                        <span style={{ marginRight: "10px" }}>
                          <VizButton
                            size={2}
                            type={"Tertiary"}
                            onClick={() => setDeleteFlag(false)}
                          >
                            Cancel
                          </VizButton>
                        </span>
                      ) : null}

                      <VizButton
                        size={2}
                        type={"Primary"}
                        onClick={createNewUser}
                      >
                        Create Role
                      </VizButton>
                    </div>
                  </div>
                </Row>
                <Row gutter={[12, 12]} style={{ cursor: "auto" }}>
                  {filtering(newRoles, searchValue)?.length > 0 ? (
                    filtering(newRoles, searchValue)?.map((item) => {
                      return (
                        <>
                          <Col
                            key={item?.roleId}
                            xs={24}
                            sm={12}
                            md={12}
                            lg={6}
                          >
                            <Card
                              className="user-card"
                              hoverable
                              style={{ maxHeight: "155px", cursor: "pointer" }}
                              onClick={() =>
                                onClickEdit(
                                  item?.permissions,
                                  item?.roleName,
                                  item?.roleId
                                )
                              }
                            >
                              <Row>
                                <Col span={4} style={{ cursor: "pointer" }}>
                                  {/* <Avatar size="large" icon={<UserOutlined />} /> */}
                                  <Avatar
                                    size={64}
                                    icon={<UserOutlined />}
                                    style={{
                                      backgroundColor: BackGroundColor(
                                        item?.roleName
                                      ),
                                      cursor: "pointer",
                                    }}
                                    className="avatar"

                                    //'#f56a00', "#87d068",'#1677ff','#fde3cf','#f56a00','#f56a00'
                                    // style={{ backgroundColor: getRandomColor() }}
                                  >
                                    <span
                                      style={{
                                        cursor: "pointer",
                                        fontSize: "15px",
                                        fontWeight: "300",
                                      }}
                                    >
                                      {item?.roleName.charAt(0).toUpperCase()}
                                    </span>
                                  </Avatar>
                                </Col>
                                <Col
                                  span={20}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <span
                                    style={{
                                      marginLeft: 45,
                                      wordBreak: 'break-word',
  overflowWrap: 'break-word',
                                    }}
                                  >
                                    {item?.roleName}
                                  </span>
                                </Col>
                              </Row>
                              <Row style={{ marginTop: 16 }}>
                                <Col
                                  span={24}
                                  className="card-actions"
                                  style={{
                                    display: "flex",
                                    // justifyContent: "flex-end",
                                    width: "100%",
                                  }}
                                  // onClick={
                                  //   !deleteFlag
                                  //     ? () =>
                                  //         onClickEdit(
                                  //           item?.permissions,
                                  //           item?.roleName,
                                  //           item?.roleId
                                  //         )
                                  //     : null
                                  // }
                                >
                                  <div style={{ width: "50%" }}></div>
                                  <div
                                    style={{
                                      width: "50%",
                                      justifyContent: "flex-end",
                                      display: "flex",
                                    }}
                                  >
                                    {item?.roleName !== "Admin" &&
                                    deleteFlag ? (
                                      <Popconfirm
                                        placement="top"
                                        title={"Delete The Role"}
                                        description={
                                          "Are you sure you want to delete the role?"
                                        }
                                        okText="Yes"
                                        cancelText="No"
                                        onConfirm={(e) => {
                                          e.stopPropagation();
                                          DeleteRole(item?.roleId);
                                        }}
                                        onClick={(e) => e.stopPropagation()}
                                        onCancel={(e) => {
                                          e.stopPropagation();
                                          setIsHovered(false);
                                          // Add your custom onClick function here
                                        }}
                                      >
                                        <button className={styles.onDelete}>
                                          <span>
                                            <DeleteOutlined />
                                          </span>
                                          <span style={{ marginLeft: "3.5px" }}>
                                            Delete
                                          </span>
                                        </button>{" "}
                                        {/* <Button
                                          type="primary"
                                          danger
                                          icon={<DeleteOutlined />}
                                          style={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            maxHeight: "27.6px",
                                            alignItems: "center",
                                          }}
                                        >
                                          Delete
                                        </Button> */}
                                        {/* <Button
                                          // type="primary"
                                          danger
                                          icon={<DeleteOutlined />}
                                          // className="onDelete"
                                          sx={{
                                            backgroundColor: "#ff4d4f",
                                            color: "#fff",
                                            fontSize: "16px",
                                            border: "#ff4df",

                                            // border: "#ff4d4f",
                                            // border-radius: 6px;
                                            // text-transform: capitalize;
                                            // background-color: #ff4d4f;
                                            // color: #fff;
                                            // margin-right: 10px;
                                            "&:hover": {
                                              backgroundColor: "#f01114",
                                            },
                                          }}
                                        >
                                          Delete
                                        </Button> */}
                                      </Popconfirm>
                                    ) : (
                                      <>
                                        <Button
                                          // type="primary"
                                          // danger
                                          // icon={<DeleteOutlined />}
                                          disabled={true}
                                          style={{ zIndex: "-99999" }}
                                        >
                                          {/* Delete */}
                                        </Button>
                                      </>
                                    )}
                                  </div>
                                </Col>
                              </Row>
                            </Card>
                          </Col>
                        </>
                      );
                    })
                  ) : loading === false ? (
                    <>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          textAlign: "center",
                          margin: "5%",
                          width: "100%",
                        }}
                      >
                        <VizParagraph type={2}>No Data</VizParagraph>
                      </div>
                    </>
                  ) : null}
                </Row>
              </div>
            </Spin>
          </div>
        </>
      )}
    </>
  );
}

export default AdminManageRole;
